import { Check, Copy } from "lucide-react";
import { useState } from "react";
import { Button } from "./button";
import { Notice } from "./feedback";

export function CopyButton({ value, label = "Copy" }: { value: string; label?: string }) {
  const [copied, setCopied] = useState(false);
  return (
    <Button
      size="sm"
      variant="secondary"
      icon={copied ? <Check size={13} /> : <Copy size={13} />}
      onClick={async () => {
        try {
          await navigator.clipboard.writeText(value);
          setCopied(true);
          setTimeout(() => setCopied(false), 1500);
        } catch {
          // clipboard blocked; the value is still visible for manual copy
        }
      }}
    >
      {copied ? "Copied" : label}
    </Button>
  );
}

/** Displays a credential exactly once. It is never stored client-side. */
export function OneTimeSecret({ label, value, note }: { label: string; value: string; note?: string }) {
  return (
    <div className="flex flex-col gap-3">
      <Notice tone="warning" title="Shown only once">
        {note ?? "Copy it now and share it through a secure channel. HostDock does not store it and cannot show it again."}
      </Notice>
      <div className="flex flex-col gap-1.5">
        <span className="text-[13px] font-medium">{label}</span>
        <div className="flex items-center gap-2">
          <code className="min-w-0 flex-1 rounded-md border border-line bg-surface-2 px-3 py-2 font-mono text-[13px] break-all select-all">{value}</code>
          <CopyButton value={value} />
        </div>
      </div>
    </div>
  );
}
